import * as stringUtils from '../string-utils'

export const obfuscateAnswer = (
  text: string,
  answers: Record<string, unknown>,
  flags: Record<string, unknown>,
): string => {
  if (flags.isFinal) {
    return stringUtils.censorString(text)
  }

  return text
}
